@if (banners$ | async; as banners) {
  @let shouldTurnOnCarousel = isMoreThanOne(banners);

  <p-carousel
    [showNavigators]="shouldTurnOnCarousel"
    [autoplayInterval]="5000"
    [circular]="shouldTurnOnCarousel"
    [numScroll]="1"
    [numVisible]="1"
    [showIndicators]="shouldTurnOnCarousel"
    [value]="banners">
    <ng-template
      #item
      let-banner>
      <app-public-home-banner-carousel-item
        [bannerId]="banner.id"
        [imageAlt]="banner.file.alt"
        [mobileImageSrc]="banner.smallFile?.url"
        [imageSrc]="banner.file.url"
        [externalLink]="banner.url" />
    </ng-template>
  </p-carousel>
}
